// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const ninetyNinetyRule: Law = {
  slug: "ninety-ninety-rule",
  title: "Ninety-ninety rule",
  definition: "The first 90% of the code takes 10% of the time. The remaining 10% takes the other 90% of the time",
  category: "theory",
  color: "#c8bc00",
  labels: ["software-engineering","management"],
  copy: ["So true. Anyone who does not agree with this?"],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
